// Ошибки bserver при сохранении рабочего места приходят как
// { code, comment, text: { rus, eng } }: text.rus — короткий заголовок,
// comment — технический текст на английском. Известные случаи объясняем по-человечески.
const KNOWN_ERRORS = [
  {
    match: /Cannot change the type of an occupied workplace/i,
    kind: 'occupiedType',
    message: 'Нельзя сменить тип, пока рабочее место занято',
    description: 'На этом рабочем месте сейчас работает оператор. Попросите его выйти из рабочего места и сохраните снова — или верните прежний тип, чтобы сохранить остальные изменения.',
  },
];

const FALLBACK_MESSAGE = 'Не удалось сохранить рабочее место';

export default function describeSaveError(error) {
  if (!error || typeof error !== 'object') {
    return { message: FALLBACK_MESSAGE, details: error ? String(error) : '' };
  }
  const { code, comment = '', text = {} } = error;
  const details = [comment, code && `код ${code}`].filter(Boolean).join(' · ');
  const known = KNOWN_ERRORS.find((item) => item.match.test(comment));
  if (known) return { ...known, details };
  return { message: text.rus || text.eng || FALLBACK_MESSAGE, details };
}
